export const SET_TIME = "SET_TIME"
export const SET_QUICK_SELECT = "SET_QUICK_SELECT"
export const SET_DAYS_SELECTED = "SET_DAYS_SELECTED"
